// export const srArtContext = '/srArt/newsInfo'

export default [

    {
        path: `/display`,
        name: '陈列展览',
        meta: {
            title: '陈列展览-上饶美术馆',

        },
        component: () =>
            import ('../views/display/display.vue'),
    },
    {
        path: `/nowplay`,
        name: '陈列展览',
        meta: {
            title: '正在展览-上饶美术馆',

        },
        component: () =>
            import ('../views/display/display.vue'),
    },
    {
        path: `/displayDetail/`,
        name: '陈列展览详请',
        meta: {
            title: '正在展览详请-上饶美术馆',

        },
        component: () =>
            import ('../views/display/displaynews.vue'),
    },
    {
        path: `/displayYugao`,
        name: '展览预告',
        meta: {
            title: '展览预告-上饶美术馆',

        },
        component: () =>
            import ('../views/display/yugao.vue'),
    },
    {
        path: `/yugaoDetail`,
        name: '展览预告详请',
        meta: {
            title: '展览预告详请-上饶美术馆',

        },
        component: () =>
            import ('../views/display/yugaonews.vue'),
    },
    {
        path: `/displayreview`,
        name: '展览回顾',
        meta: {
            title: '展览回顾-上饶美术馆',

        },
        component: () =>
            import ('../views/display/review.vue'),
    },
    {
        path: `/reviewDetail`,
        name: '展览回顾详请',
        meta: {
            title: '展览回顾详请-上饶美术馆',

        },
        component: () =>
            import ('../views/display/reviewnews.vue'),
    }

]